import { useRef } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';

const { FiArrowLeft, FiArrowRight } = FiIcons;
const services = [
  { title: 'Hair Styling', text: 'Cuts, blow-dries and styling shaped around you.', image: 'photo-1562322140-8baeececf3df' },
  { title: 'Hair Colour', text: 'From soft dimension to a confident new shade.', image: 'photo-1522337360788-8b13dee7a37e' },
  { title: 'Facial & Skin Care', text: 'Restorative facials and care for your skin.', image: 'photo-1570172619644-dfd03ed5d881' },
  { title: 'Manicure & Pedicure', text: 'A fresh, polished finish from hand to toe.', image: 'photo-1604654894610-df63bc536371' },
  { title: 'Makeup', text: 'Camera-ready or beautifully understated looks.', image: 'photo-1487412947147-5cebf100ffc2' },
  { title: 'Bridal Services', text: 'Personalised beauty for your once-in-a-lifetime day.', image: 'photo-1595476108010-b4d1f102b1b1' },
  { title: "Men's Grooming", text: 'Sharp cuts, beard shaping and everyday care.', image: 'photo-1503951914875-452162b0f3f1' }
];

function Services() {
  const track = useRef(null);
  const move = (direction) => track.current?.scrollBy({ left: direction * 310, behavior: 'smooth' });

  return (
    <section className="section services-section" id="services">
      <div className="container">
        <Reveal className="services-heading-row">
          <SectionHeading eyebrow="The good stuff" title="A little care, head to toe." description="Professional services, considered products and a team who love what they do." />
          <div className="slider-controls">
            <button aria-label="Previous services" onClick={() => move(-1)}><SafeIcon icon={FiArrowLeft} /></button>
            <button aria-label="Next services" onClick={() => move(1)}><SafeIcon icon={FiArrowRight} /></button>
          </div>
        </Reveal>
        <div className="services-track" ref={track}>
          {services.map((service, index) => (
            <article className="service-card" key={service.title}>
              <div className="service-image"><img src={`https://images.unsplash.com/${service.image}?auto=format&fit=crop&w=620&q=82`} alt={service.title} /><span>0{index + 1}</span></div>
              <div className="service-card-copy"><h3>{service.title}</h3><p>{service.text}</p><a href="#appointment" aria-label={`Book ${service.title}`}>Book a service <span>↗</span></a></div>
            </article>
          ))}
        </div>
        <p className="slider-hint">Swipe to explore all services <span>→</span></p>
      </div>
    </section>
  );
}

export default Services;
